import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import SC from './styles';

const StatefulMaskedInput = ({ onChange, ...props }) => {
  const [value, setValue] = useState(props.value);

  return (
    <MaskedInput
      value={props.value || value}
      onChange={e => {
        setValue(e.target.value);
        return onChange && onChange(e, _unmask(e.target.value));
      }}
      guide={false}
      mask={createNumberMask()}
      render={(ref, inputProps) => (
        <SC.Input {...props} {...inputProps} ref={ref} />
      )}
    />
  );
};

export default StatefulMaskedInput;

export const _unmask = value => {
  return value.replace(/\W+/g, '');
};
